// import React from 'react'; // Not needed without StrictMode
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Suppress ResizeObserver loop error (benign browser warning)
// This error is harmless and occurs when ResizeObserver can't deliver all observations in a single animation frame
const resizeObserverErr = (e: ErrorEvent): void => {
  if (e.message === 'ResizeObserver loop completed with undelivered notifications.' ||
      e.message === 'ResizeObserver loop limit exceeded') {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
};
window.addEventListener('error', resizeObserverErr);

// Also suppress unhandled promise rejections for ResizeObserver
window.addEventListener('unhandledrejection', (e: PromiseRejectionEvent) => {
  if (e.reason?.message?.includes('ResizeObserver')) {
    e.preventDefault();
  }
});

// Suppress React's error overlay for ResizeObserver errors
const originalConsoleError = console.error;
console.error = (...args: any[]) => {
  if (args[0]?.includes?.('ResizeObserver') || 
      (typeof args[0] === 'string' && args[0].includes('ResizeObserver'))) {
    return;
  }
  originalConsoleError.apply(console, args);
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  // StrictMode disabled to prevent duplicate API requests during development
  // <React.StrictMode>
    <App />
  // </React.StrictMode>
);
